import { combineReducers } from 'redux';

import { createCmsDuck } from 'helpers/cms';
import { createDuck } from 'helpers/duckTools';
import api from 'store/actions/api';
import adsResultSelector from './adsResultSelector';

export const adsDuck = createDuck(
  'FAVORITES_OVERVIEW/ADS',
  {
    result: [],
    error: null,
    isLoading: false,
    isLoaded: false,
  },
  {
    loaders: {
      loadAds: {
        fetch: api.getAdsByType,
        resultSelector: adsResultSelector,
      },
    },
  },
);

export const cmsDuck = createCmsDuck({
  path: ['favoritesOverview', 'cms'],
});

export const uiDuck = createDuck('FAVORITES_OVERVIEW/UI', {});

const reducer = combineReducers({
  ads: adsDuck,
  cms: cmsDuck,
  ui: uiDuck,
});

reducer.key = 'favoritesOverview';

export { reducer };
